import { useNavigate, useParams } from "react-router-dom";
import useFlow from "../hooks/useFlow";
import { useEffect, useState } from "react";
import GoBack from "../components/GoBack";
import { toast } from "react-toastify";

export default function Landing() {
  const navigate = useNavigate();
  const { siteId } = useParams();
  const { getLocations, setSelectedSiteId, selectedSiteId } = useFlow();

  const [locationList, setLocationList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadLocations = async () => {
      try {
        if (!siteId) return;
        setLoading(true);
        setSelectedSiteId(siteId);
        setLocationList([]);
        const locations = await getLocations(siteId);
        const locWithoutOnline = locations.filter(
          (loc) => loc.locationId !== 98
        );
        setLocationList(locWithoutOnline);
        setLoading(false);
      } catch (e) {
        toast.error(`Something went wrong! ${e?.message}`);
        setLoading(false);
        navigate("/");
      }
    };
    loadLocations();
  }, [siteId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (locationList.length == 1) {
      navigate(`/${selectedSiteId}/${locationList[0].locationId}`);
    }
  }, [locationList]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <GoBack />
      <div className="vh-100 d-flex flex-column justify-content-center align-items-center">
        <h1 className="welcome text-center">
          Welcome!
          <br />
          <b>Select your Location</b>
        </h1>
        <div className="mt-5 d-flex flex-row justify-content-evenly align-items-center">
          <select
            className="form-select form-select-lg"
            data-testid="location-select"
            onChange={(e) => {
              navigate(`/${selectedSiteId}/${e.target.value}`);
            }}
            disabled={!selectedSiteId || locationList.length == 0 || loading}
          >
            <option value={"DEFAULT"}>
              {loading ? "Loading..." : "Select your location"}
            </option>
            {locationList.map((loc, index) => (
              <option key={index} value={loc.locationId}>
                {loc.name}
              </option>
            ))}
          </select>

          {loading && (
            <div className="ms-3 d-flex align-items-center">
              <div
                className="spinner-grow spinner-grow-lg text-secondary"
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
